// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__3NgZS","load2":"Spinner_load2__3ywph"};